import { Combobox, GetItemsProps } from 'medere-ui-framework';
import { FinancialAccountDTO } from '../dto/FinancialAccountDTO';
import { getAllFinancialAccounts } from '../services/FinancialAccountController';

interface FinancialAccountComboProps {
  value: FinancialAccountDTO | null;
  onChange: (value: FinancialAccountDTO | null) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
}

async function getActiveFinancialAccounts({ filterValue }: GetItemsProps): Promise<FinancialAccountDTO[]> {
  const accounts = await getAllFinancialAccounts();
  const active = accounts.filter((a) => a.active);
  if (!filterValue) return active;
  const lower = filterValue.toLowerCase();
  return active.filter((a) => a.name.toLowerCase().includes(lower));
}

export default function FinancialAccountCombo({
  value,
  onChange,
  label = 'Cuenta financiera',
  disabled = false,
  required = false,
  className = '',
}: Readonly<FinancialAccountComboProps>) {
  return (
    <Combobox
      className={className}
      value={value}
      label={label}
      getItems={getActiveFinancialAccounts}
      optionLabel="name"
      disable={disabled}
      setValue={(account: FinancialAccountDTO | null) => onChange(account)}
      required={required}
    />
  );
}
